module.exports = __webpack_public_path__ + "static/media/nz.07d3ae50.svg";